import { Button, Grid, MenuItem, Tab, Tabs } from '@mui/material'
import { Field, Form, Formik } from 'formik'
import { TextField } from 'formik-material-ui'
import { useMemo, useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import LoteProduto from './loteProduto'
import CurrencyField from '../../../components/CurrencyField/CurrencyField'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'

const EdicaoProduto = ({
  dadosProduto,
  voltar,
  setTela,
  dadosLote,
  setDadosLote,
  setRefresh,
}) => {
  const retornaFornecedor = useMemo(
    () => ({
      idProduto: dadosProduto?.[0] || undefined,
      cdProduto: dadosProduto?.[1] || '',
      dsNome: dadosProduto?.[2] || '',
      dsProduto: dadosProduto?.[3] || '',
      snControlado: dadosProduto?.[4] || '',
      qtEstoqueMinimo: dadosProduto?.[6] || undefined,
      vlProduto: dadosProduto?.[5] || 0.0,
      dtInclusao: dadosProduto?.[7] || undefined,
      dtExclusao: dadosProduto?.[8] || undefined,
      cdGtin: dadosProduto?.[9] || '',
      acViaProduto: dadosProduto?.[10] || [],
      acFluxoAtendimento: dadosProduto?.[11] || [],
      snManipulado: dadosProduto?.[12] || '',
      qtdEstoque: dadosProduto?.[13] || 0,
      acPlanoConta: dadosProduto?.[15] || [],
    }),
    [dadosProduto],
  )

  const [tab, setTab] = useState(0)

  const salva = async (values) => {
    const payload = {
      ...values,
      planosDeConta: values.acPlanoConta.map((item) => item[0][0]),
      listaVia: values?.acViaProduto?.map((item) => item?.[0]?.[0]),
      listaFluxo: values?.acFluxoAtendimento?.map((item) => item?.[0]?.[0]),
    }
    const res = await metodoPrograma('salva', payload)
    if (res.status) {
      setRefresh((prev) => prev + 1)
      voltar()
    }
  }

  return (
    <Formik
      enableReinitialize
      initialValues={retornaFornecedor}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({
        isSubmitting,
        submitForm,
        setFieldValue,
        values,
        touched,
        errors,
      }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Tabs
              value={tab}
              onChange={(_, v) => setTab(v)}
              textColor="primary"
              indicatorColor="primary"
              style={{ marginBottom: 10 }}
            >
              <Tab value={0} label="Dados do Produto" />
              <Tab
                value={1}
                disabled={!dadosProduto?.[0]}
                label="Lotes do Produto"
              />
            </Tabs>
          </Grid>
          <Grid item xs={12}>
            {tab === 0 && (
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="cdProduto"
                    label="Codigo do Produto"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={9}>
                  <Field
                    component={TextField}
                    name="dsNome"
                    label="Nome"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="cdGtin"
                    label="Código de Barras (EAN/GTIN)"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="qtEstoqueMinimo"
                    label="Estoque Mínimo"
                    type="number"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="snControlado"
                    label="Controlado"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                    select
                  >
                    <MenuItem value={'S'}>Sim</MenuItem>
                    <MenuItem value={'N'}>Não</MenuItem>
                  </Field>
                </Grid>
                <Grid item xs={3}>
                  <Field
                    component={TextField}
                    name="snManipulado"
                    label="Manipulado"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                    select
                  >
                    <MenuItem value={'S'}>Sim</MenuItem>
                    <MenuItem value={'N'}>Não</MenuItem>
                  </Field>
                </Grid>
                <Grid item xs={3}>
                  <CurrencyField
                    value={values?.vlProduto}
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    label="Valor Venda"
                    size="small"
                    onChange={(v) => {
                      setFieldValue('vlProduto', v)
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={9}>
                  <AutoComplete
                    multiple
                    InputLabelProps={{ shrink: true }}
                    filterSelectedOptions
                    disabled={isSubmitting}
                    label="Via de Acesso"
                    metodo="buscaViaAdministracao"
                    value={values.acViaProduto}
                    size="small"
                    onChange={(_, val) => setFieldValue('acViaProduto', val)}
                    textFieldProps={{
                      helperText: touched?.acViaProduto && errors?.acViaProduto,
                      error: touched?.acViaProduto && !!errors?.acViaProduto,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <AutoComplete
                    multiple
                    InputLabelProps={{ shrink: true }}
                    filterSelectedOptions
                    disabled={isSubmitting}
                    label="Fluxo de Atendimento"
                    metodo="buscaFluxoAtendimento"
                    value={values.acFluxoAtendimento}
                    size="small"
                    onChange={(_, val) =>
                      setFieldValue('acFluxoAtendimento', val)
                    }
                    textFieldProps={{
                      helperText:
                        touched?.acFluxoAtendimento &&
                        errors?.acFluxoAtendimento,
                      error:
                        touched?.acFluxoAtendimento &&
                        !!errors?.acFluxoAtendimento,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    component={TextField}
                    multiline
                    name="qtdEstoque"
                    label="Qtd. Estoque"
                    fullWidth
                    margin="dense"
                    disabled
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12}>
                  <AutoComplete
                    multiple
                    filterSelectedOptions
                    InputLabelProps={{ shrink: true }}
                    disabled={isSubmitting}
                    label="Plano de Conta"
                    codigo="CtrlProduto"
                    metodo="buscaPlanoConta"
                    value={values.acPlanoConta}
                    getOptionLabel={(item) =>
                      item?.[1]
                        ? [item[2], item[1]].filter(Boolean).join(' - ')
                        : ''
                    }
                    isOptionEqualToValue={(option, value) =>
                      option?.[0]?.[0] === value?.[0]?.[0]
                    }
                    size="small"
                    onChange={(_, val) => setFieldValue('acPlanoConta', val)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Field
                    component={TextField}
                    minRows={5}
                    multiline
                    name="dsProduto"
                    label="Descrição / Composição"
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    size="small"
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{ display: 'flex', flexDirection: 'row-reverse' }}
                >
                  <Button
                    onClick={submitForm}
                    disabled={isSubmitting}
                    variant="contained"
                    color="primary"
                    style={{ margin: '5px' }}
                  >
                    Salvar
                  </Button>
                  <Button
                    onClick={voltar}
                    variant="contained"
                    color="secondary"
                    style={{ margin: '5px' }}
                  >
                    Cancelar
                  </Button>
                </Grid>
              </Grid>
            )}
            {tab === 1 && (
              <Grid item xs={12}>
                <LoteProduto
                  {...{
                    idProduto: dadosProduto?.[0],
                    setTela,
                    dadosLote,
                    setDadosLote,
                  }}
                />
              </Grid>
            )}
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default EdicaoProduto
